import { fetchConfig } from "./configService";

let appConfig = null;

export const getAppConfig = async () => {
  if (!appConfig) {
    appConfig = await fetchConfig();
  }
  return appConfig;
};